import { convertImageUrlToBase64 } from "@src/appV2/Agents/components/ContractorBadge/utils/convertImageUrlToBase64";
import { type QueryClient, useQuery } from "@tanstack/react-query";

const baseQueryKey = ["badge-picture"];

export function resetGetPictureForBadgeQuery(queryClient: QueryClient) {
  void queryClient.resetQueries({ queryKey: baseQueryKey });
}

function getQueryKey(url: string | undefined) {
  return [baseQueryKey, url ?? ""];
}

export function useGetPictureForBadge(
  url: string | undefined,
  options?: {
    refetchOnWindowFocus?: boolean;
  }
) {
  return useQuery({
    queryKey: getQueryKey(url),
    queryFn: async () => {
      if (!url) {
        return "";
      }

      return await convertImageUrlToBase64(url);
    },
    refetchOnWindowFocus: options?.refetchOnWindowFocus,
  });
}
